import { Switch } from 'antd'
import { FC, useState } from 'react'
import { useTwilioIntegrationStoreMutation } from '../api'
import { TAddTwilioInput, TwilioData } from '../types'

// Voice reuses the tenant's existing SMS credentials - every save re-submits the
// full combined payload since the backend exposes one upsert endpoint for both.
const VoiceCallingSection: FC<{ data: TwilioData }> = ({ data }) => {
 const [mutate, { isLoading }] = useTwilioIntegrationStoreMutation()
 const [savingField, setSavingField] = useState<'voice' | 'recording'>()

 const save = async (
  overrides: Partial<TAddTwilioInput>,
  field: 'voice' | 'recording',
 ) => {
  setSavingField(field)
  try {
   await mutate({
    twilio_account_id: data.twilio_account_id,
    twilio_auth_token: data.twilio_auth_token,
    phone_number: data.phone_number,
    voice_enabled: data.voice_enabled,
    call_recording_enabled: data.call_recording_enabled,
    voice_fallback_number: data.voice_fallback_number,
    ...overrides,
   }).unwrap()
  } finally {
   setSavingField(undefined)
  }
 }

 return (
  <div className="voice-calling-section mt-4">
   <h3>Voice Calling</h3>
   <div className="voice-toggle-row">
    <span>Enable Voice</span>
    <Switch
     checked={!!data.voice_enabled}
     loading={isLoading && savingField === 'voice'}
     onChange={(checked) => save({ voice_enabled: checked }, 'voice')}
    />
   </div>
   {data.voice_enabled && (
    <div className="voice-toggle-row">
     <span>Record calls</span>
     <Switch
      checked={!!data.call_recording_enabled}
      loading={isLoading && savingField === 'recording'}
      onChange={(checked) =>
       save({ call_recording_enabled: checked }, 'recording')
      }
     />
    </div>
   )}
  </div>
 )
}

export default VoiceCallingSection
